const cleanFieldsForms = ( $forms ) => {
	$forms.each(function() {
		$(this).trigger('reset')
			.find("input, textarea")
			.blur()
			.parent()
			.removeClass("form__field_error");
	});
};

module.exports = cleanFieldsForms;
